
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.999 19.25a.372.372 0 00-.373.375.375.375 0 10.517-.347.375.375 0 00-.144-.028M4.589 12c4.093-3.753 10.726-3.753 14.818 0M1.594 7.804c5.747-5.072 15.065-5.072 20.812 0M7.579 15.821a6.276 6.276 0 018.841 0","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    